var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgDone = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2B4157",
    fillRule: "evenodd",
    d: "M11.078 4.142c-.29-.228-.708-.176-.936.114L5.44 10.26 3.186 7.463c-.232-.286-.65-.333-.937-.101-.287.231-.332.651-.102.937l2.78 3.452c.127.157.317.249.52.249h.004c.203-.002.395-.096.52-.256l5.22-6.667c.228-.29.177-.709-.113-.935zm3.333 0c-.29-.228-.708-.176-.935.114L8.771 10.26l-.403-.5-.843 1.079.733.911c.128.157.318.249.52.249h.005c.203-.002.395-.096.52-.256l5.22-6.667c.228-.29.178-.709-.113-.935zM6.653 7.629L5.81 8.707l-.328-.408c-.231-.286-.186-.706.101-.938.287-.23.707-.184.937.102l.134.166z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDone, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/done.2186e163.svg";
export { ForwardRef as ReactComponent };